import { actions as dataFetchActions } from '@buffer-mono/async-data-fetch'
import type { Middleware } from '@reduxjs/toolkit'

import type { AppDispatch, RootState } from '~publish/legacy/store'
import { isLegacyAction } from '~publish/legacy/store/isAction'

import { actionTypes } from './reducer'

const middleware: Middleware<object, RootState, AppDispatch> =
  ({ dispatch }) =>
  (next) =>
  (action): void => {
    next(action)
    if (!isLegacyAction(action)) return
    switch (action.type) {
      case 'INIT_PROFILES':
        dispatch(
          dataFetchActions.fetch({
            name: 'profiles',
          }),
        )
        break
      case actionTypes.FETCH_SINGLE_PROFILE:
        dispatch(
          dataFetchActions.fetch({
            name: 'singleProfile',
            args: {
              profileId: action.profileId,
              message: action.message,
            },
          }),
        )
        break
      default:
        break
    }
  }

export default middleware
